 const labels = document.querySelectorAll('.cardproduct_variant label');
if(labels){
labels.forEach(label => {
    label.addEventListener('click', () => {
        const value = label.getAttribute('value');
        const price = label.getAttribute('price');
        const comprice = label.getAttribute('comprice');
        const card = label.closest('.card-wrapper');

        if (!card) return;

        const button = card.querySelector('.add-to-cart');
        const priceDiv = card.querySelector('.price__regular bdi');
        const salePrice = card.querySelector('.price-item--sale bdi');
        const salecomPrice = card.querySelector('.price__compare bdi');

        if (button) {
            button.setAttribute('data-variant-id', value);
        }

        if (price) {
            const formattedPrice = price.endsWith('.00') ? price.replace('.00', '') : price;
            if (priceDiv) priceDiv.textContent = formattedPrice;
            if (salePrice) salePrice.textContent = formattedPrice;
        }
        if (comprice) {
            const formattedcomPrice = comprice.endsWith('.00') ? comprice.replace('.00', '') : comprice;
            if (salecomPrice) salecomPrice.textContent = formattedcomPrice;
        }

        // Remove 'selected' from all labels in this card only
        const allLabelsInCard = card.querySelectorAll('.cardproduct_variant label');
        allLabelsInCard.forEach(l => l.classList.remove('selected'));
        label.classList.add('selected');
    });

    // --- Pre-selection logic inside the forEach ---
    const card = label.closest('.card-wrapper');
    if (!card) return;

    const button = card.querySelector('.add-to-cart');
    const priceDiv = card.querySelector('.price__regular bdi');
    const salePrice = card.querySelector('.price-item--sale bdi');
    const salecomPrice = card.querySelector('.price__compare bdi');
    const labelValue = label.getAttribute('value');
    const labelPrice = label.getAttribute('price');
    const labelcomprice = label.getAttribute('comprice');

    if (button && button.getAttribute('data-variant-id') === labelValue) {
        const allLabelsInCard = card.querySelectorAll('.cardproduct_variant label');
        allLabelsInCard.forEach(l => l.classList.remove('selected'));
        label.classList.add('selected');

        if (labelPrice) {
            const formattedPrice = labelPrice.endsWith('.00') ? labelPrice.replace('.00', '') : labelPrice;
            if (priceDiv) priceDiv.textContent = formattedPrice;
            if (salePrice) salePrice.textContent = formattedPrice;
        }
        if (labelcomprice) {
            const formattedcomPrice = labelcomprice.endsWith('.00') ? labelcomprice.replace('.00', '') : labelcomprice;
            if (salecomPrice) salecomPrice.textContent = formattedcomPrice;
        }
    }
});
}
// $('.announcement-slide').owlCarousel({
//     items: 1,
//     loop: true,
//     autoplay: true,
//     autoplayTimeout: 4000, // 2 seconds between slides
//     autoplaySpeed: 3000, // 2 seconds transition animation
//     autoplayHoverPause: true,
//     dots: false,
//     smartSpeed: 1000,
//     nav: false,
// });

document.addEventListener("DOMContentLoaded", function() {
    var payButton = document.querySelector('[data-tg-refresh="payment_gateway"]');
    if (payButton) {
        payButton.style.display = "none";
    }
});
$('.hero-products-slider__carousel').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    navText: ['<img src="https://cdn.shopify.com/s/files/1/0712/5621/1737/files/icons8-back-50.png?v=1751521128">', '<img src="https://cdn.shopify.com/s/files/1/0712/5621/1737/files/icons8-forward-50.png?v=1751521128">'],
    responsive: {
        0: {
            items: 1,
            margin: 6
        },
        768: {
            items: 2
        },
        1024: {
            items: 2
        }
    }
});

$('.npdp_available_offers_slider').owlCarousel({
    loop: true,
    margin: 15,
    nav: false,
    dots: false,
    navText: ['<img src="https://cdn.shopify.com/s/files/1/0712/5621/1737/files/icons8-back-50.png?v=1751521128">', '<img src="https://cdn.shopify.com/s/files/1/0712/5621/1737/files/icons8-forward-50.png?v=1751521128">'],
    responsive: {
        0: {
            items: 1.3, // Show 3 slides on mobile
            margin: 5
        },
        768: {
            items: 2 // Show 1 slide on desktop
        },
        1024: {
            items: 2 // Show 1 slide on desktop
        }
    }
});

function copyToClipboard(el) {
    const code = el.querySelector('.copy-code').innerText.trim();
    if (!code) return;
    navigator.clipboard.writeText(code).then(() => {
        const tooltip = el.querySelector('.tooltip');
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '1';
        tooltip.innerText = 'Copied!';

        setTimeout(() => {
            tooltip.style.visibility = 'hidden';
            tooltip.style.opacity = '0';
        }, 1500);
    });
}
document.addEventListener('DOMContentLoaded', function() {
    const triggerLink = document.querySelector('a.why-it-works');
    const scrollTarget = document.getElementById('collapsible-content');

    if (triggerLink && scrollTarget) {
        triggerLink.addEventListener('click', function(e) {
            e.preventDefault(); // prevent default link behavior

            scrollTarget.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    }
});
const announcementBar = document.querySelector('.custom-announcement');
if (announcementBar) {
    window.onscroll = function() {
        const offsetTop = announcementBar.offsetTop;

        // Check if we've scrolled past the original position of the announcement bar
        if (window.scrollY > offsetTop) {
            // Add the sticky class if the scroll is past the bar's position
            announcementBar.classList.add('sticky');
        } else {
            // Remove the sticky class when scrolling back up
            announcementBar.classList.remove('sticky');
        }
    }
}; 
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const targetId = this.getAttribute('href');
    const targetEl = document.querySelector(targetId);

    if (targetId.length > 1 && targetEl) {
      e.preventDefault();

      const offset = 65; // yahan jitna minus chahiye (header height)
      const elementPosition = targetEl.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });
});
   $('.logo_slider').owlCarousel({
       loop: true,
       dots:false,
       nav:true,
       navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/></svg>'],
       responsive: {
       0: { items: 2 },
       768: { items: 4
       },
       1024: { items: 5 },
       1280: { items: 5 }
       }
       });
        $('.block_slider').owlCarousel({
       loop: true,
       dots:false,
       nav:true,
       navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/></svg>'],
       responsive: {
       0: { items: 2 },
       768: { items: 4
       },
       1024: { items: 5 },
       1280: { items: 5 }
       }
       });
       $('.slider_imaqge').owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000, 
    autoplaySpeed: 3000, 
    autoplayHoverPause: true,
    dots: true,
    smartSpeed: 1000,
    nav: false,
});
$('.image-carousel').owlCarousel({
       loop: true,
       dots:false,
       nav:false,
       margin: 10,
       responsive: {
       0: { items: 1.6 },
       768: { items: 4
       },
       1024: { items: 6 },
       1280: { items: 6 }
       }
});
$('.video-carousel').owlCarousel({
       loop: true,
       dots:false,
       nav:false,
        margin: 10,
       responsive: {
       0: { items: 2 },
       768: { items: 4
       },
       1024: { items: 7 },
       1280: { items: 7 }
       }
});
 document.querySelector('.delivery').addEventListener('click', function (e) {
    e.preventDefault();

    const targetClass = this.getAttribute('href'); // .about-section
    const targetEl = document.querySelector('.clickpost-edd__heading');

    if (!targetEl) return;

    const offset = 65; // header height
    const targetPosition =
      targetEl.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  });
